import React from 'react';

import UserPermissionViewer from '@/components/blocks/rbac/user-permission-viewer';
import { useGlobalState } from '@/contexts/GlobalStateContext';
import { User } from '@/types/sheets';

interface UserPermissionViewerSheetProps {
  user?: User;
}

const UserPermissionViewerSheet: React.FC<UserPermissionViewerSheetProps> = ({
  user,
}) => {
  const { hideSheet, state } = useGlobalState();

  const handleClose = () => {
    hideSheet('user-permission-viewer');
  };

  // Get the user data from the sheet data if not provided via props
  const currentSheet = state.sheets.find(
    sheet => sheet.type === 'user-permission-viewer'
  );
  const userData = user || currentSheet?.data?.user;

  if (!userData) {
    return (
      <div className='flex items-center justify-center p-8'>
        <div className='text-center text-gray-60'>
          <p>No user data available</p>
        </div>
      </div>
    );
  }

  return <UserPermissionViewer user={userData} onClose={handleClose} />;
};

export default UserPermissionViewerSheet;
